module.exports = __webpack_public_path__ + "static/img/8.96a9a62.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/8.png
// module id = yOq8
// module chunks = 0